"use client";

import { useRequestGeolocation } from "@packages/sdk";
import { useEffect } from "react";

import { handleConsentFromGeolocation } from "../utils/handleConsentFromGeolocation";
import { useConsentContext } from "./useConsentContext";

export const useHandleConsentFromGeolocation = () => {
  const { setConsent, setCountryCode, setIsConsentModalVisible } =
    useConsentContext();
  const { query: queryGeolocation } = useRequestGeolocation();

  useEffect(() => {
    handleConsentFromGeolocation({
      geolocation: queryGeolocation.data,
      setConsent,
      setCountryCode,
      setIsConsentModalVisible,
    });
  }, [queryGeolocation.data]);
};
